import type { FaireProductEntity } from "../../entity_types/product";

export const p_9pxzp2jk5z: FaireProductEntity = {
  token: "p_9pxzp2jk5z",
  type: "product",
  name: "Worka Chelbesa",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl: "https://cdn.faire.com/fastly/393f290ee47d3e660ce68e34fa993811dbad1a3bf99638dfa247decbf539cdf9.png",
  galleryImageUrls: [],
  priceDollars: 17,
  description: "This seasonal single origin is one that reflects everything we love about Ethiopian coffee: delicate, floral, and bright, grown at high altitude in the traditional garden systems of Gedeo Zone in the Southern Worka Chelbessa village.",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:45.245Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
